import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { sortableElement, sortableHandle } from 'react-sortable-hoc';
import { get, map, filter } from 'lodash';
import { Switch } from 'antd';
import { object, number, func, bool } from 'prop-types';
import { Icon, FormInput, Text, Row } from '../../../../common';
import { typeQuestions } from '../../../../../utils/misc';

export const CustomCheckbox = styled.div`
    width: 16px;
    height: 16px;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
`;

export const CustomRadioButton = styled.div`
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: #fff;
    border: solid 1px #d9d9d9;
`;

const DragHandle = sortableHandle(({ isHoveringOption, isActiveQuestion }) => (
    <Icon
        name='drag-vertical'
        color={(isHoveringOption && isActiveQuestion) ? '#1fa02e' : 'rgb(244, 244, 244)'}
        size={20}
    />
));

const SortableItem = sortableElement(({
    option,
    isActiveOption,
    isHoveringOption,
    setIsHoveringOption,
    setActiveOptionId,
    isActiveQuestion,
    sortStart,
    question,
    updateQuestions,
    typeQuestion,
    setShowOtherBtn
}) => {
    const typeOption = get(option, 'type');
    const idOption = get(option, 'idOption');
    const updateOptions = (key, value) => {
        const optionsUpdated = map(get(question, 'options'), (item) => {
            return get(item, 'idOption') === idOption
            ? { ...item, [key]: value }
            : item;
        });

        updateQuestions('options', optionsUpdated);
    };

    const removeOption = () => {
        setShowOtherBtn(true);
        const optionsUpdated = filter(get(question, 'options'), (item) => idOption !== get(item, 'idOption'));
        updateQuestions('options', optionsUpdated);
    };

    return <Row
        justify='flex-start'
        align='center'
        gap={10}
        zIndex={1000}
        minHeight='35px'
        onMouseEnter={() => !sortStart && setIsHoveringOption(true)}
        onMouseLeave={() => !sortStart && setIsHoveringOption(false)}
        onClick={() => setActiveOptionId(idOption)}
    >
        {typeOption === 2
            ? <div style={{ width: 20 }} />
            : <DragHandle isHoveringOption={isHoveringOption} isActiveQuestion={isActiveQuestion} />
        }
        {typeQuestion === typeQuestions.MULTIPLE ? <CustomCheckbox /> : <CustomRadioButton />}
        {isActiveOption && isActiveQuestion && !(typeOption === 2)
            ? <Row>
                <FormInput
                    type='input'
                    placeholder='Ingresar opción'
                    style={{ margin: 0 }}
                    value={get(option, 'description')}
                    onChange={({ target }) => updateOptions('description', get(target, 'value'))}
                />
            </Row>
            : <Text
                text={get(option, 'description')}
                style={{ borderBottom: (isHoveringOption && isActiveQuestion) && '1px solid #C0C0C0' }}
            />
        }
        {typeOption === 2 && <div style={{ display: 'flex', direction: 'row', gap: 10, justify: 'center', alignItems: 'center', marginLeft: 20 }}>
            <Switch checked={get(option, 'required')} onChange={(value) => updateOptions('required', value)} />
            <div style={{ fontWeight: 'bold', fontSize: '0.75rem' }}>Respuesta obligatoria</div>
        </div>}
        <Row justify='flex-end'>
            {(isHoveringOption && isActiveQuestion) && <Icon name='close' color='#1fa02e' size={20} pointer onClick={removeOption} top={3} />}
        </Row>
    </Row>;
});

const MultipleOption = ({
    option,
    index,
    activeOptionId,
    setActiveOptionId,
    isActiveQuestion,
    sortStart,
    indexLastOptionDragged,
    optionMoved,
    question,
    updateQuestions,
    typeQuestion,
    setShowOtherBtn
}) => {
    const [isHoveringOption, setIsHoveringOption] = useState(false);
    const isActiveOption = activeOptionId === get(option, 'idOption');
    const disableHoveringLastOptionDragged = indexLastOptionDragged === index;

    useEffect(() => {
        (disableHoveringLastOptionDragged && optionMoved) && setIsHoveringOption(false);
    }, [indexLastOptionDragged]);

    return <SortableItem
        index={index}
        option={option}
        isHoveringOption={isHoveringOption}
        setIsHoveringOption={setIsHoveringOption}
        isActiveOption={isActiveOption}
        setActiveOptionId={setActiveOptionId}
        isActiveQuestion={isActiveQuestion}
        sortStart={sortStart}
        question={question}
        updateQuestions={updateQuestions}
        typeQuestion={typeQuestion}
        setShowOtherBtn={setShowOtherBtn}
    />;
};

MultipleOption.propTypes = {
    option: object,
    index: number,
    activeOptionId: number,
    setActiveOptionId: func,
    isActiveQuestion: bool,
    sortStart: bool,
    indexLastOptionDragged: number,
    optionMoved: bool,
    question: object,
    updateQuestions: func,
    typeQuestion: number,
    setShowOtherBtn: bool
};

export default MultipleOption;
